/**
 * 专题创建
 * Create by liaokai on 2020-06-15 10:22:54
 */
import {toPost} from "../../http-utils";

export const subjectStore = toPost<
    {
        title : string
        synopsis : string
        poster : string
        subject_dir : {
            "live_id":string,
            "sort": number
        }   //json数据
    },
    {

    }
>("/merchant/live/subjectStore");

